import { render, staticRenderFns } from "./measurements.vue?vue&type=template&id=1dbd3520&scoped=true&"
import script from "./measurements.vue?vue&type=script&lang=js&"
export * from "./measurements.vue?vue&type=script&lang=js&"
import style0 from "./measurements.vue?vue&type=style&index=0&id=1dbd3520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbd3520",
  null
  
)

component.options.__file = "measurements.vue"
export default component.exports